import { render, staticRenderFns } from "./FileDropZone.vue?vue&type=template&id=c772ce82&scoped=true&"
import script from "./FileDropZone.vue?vue&type=script&lang=ts&"
export * from "./FileDropZone.vue?vue&type=script&lang=ts&"
import style0 from "./FileDropZone.vue?vue&type=style&index=0&id=c772ce82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c772ce82",
  null
  
)

export default component.exports